export class FloatingLabel {
    /**
     * @type {HTMLElement}
     * @private
     */
    _domElm;

    /**
     * @type {HTMLElement}
     * @private
     */
    _label;

    /**
     * @type {HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement}
     * @private
     */
    _input;

    get domElm() {
        return this._domElm;
    }

    set domElm(value) {
        this._domElm = value;
    }

    get label() {
        return this._label;
    }

    set label(value) {
        this._label = value;
    }

    get input() {
        return this._input;
    }

    set input(value) {
        this._input = value;
    }

    constructor(domElm) {
        this.domElm = domElm;
        this.label = this.domElm;
        this.input = this.domElm.querySelector('input, textarea, select');

        if (!this.input) return;

        this.init();
    }

    init() {
        // Extraire le texte du label et le mettre dans data-label
        const labelText = this.getLabelText();
        if (labelText) {
            this.label.setAttribute('data-label', labelText);
            // Vider le contenu texte du label (garder seulement le span avec l'input)
            this.cleanLabelContent();
        }

        // Ajouter la classe active si le champ a déjà une valeur
        this.checkValue();

        // Événements sur l'input
        this.input.addEventListener('focus', () => this.activate());
        this.input.addEventListener('blur', () => this.checkValue());
        this.input.addEventListener('input', () => this.checkValue());

        // Pour les select, écouter aussi le changement
        if (this.input.tagName === 'SELECT') {
            this.input.addEventListener('change', () => this.checkValue());
            // Activer au click sur le select
            this.input.addEventListener('click', () => this.activate());
        }

        // Click sur le label pour focus l'input
        this.label.addEventListener('click', (e) => {
            if (e.target === this.label) {
                this.input.focus();
            }
        });
    }

    getLabelText() {
        // Récupérer le texte du label (avant le span)
        const clone = this.label.cloneNode(true);
        const span = clone.querySelector('.wpcf7-form-control-wrap');
        if (span) span.remove();
        return clone.textContent.trim();
    }

    cleanLabelContent() {
        // Garder seulement le span avec l'input
        const span = this.label.querySelector('.wpcf7-form-control-wrap');
        if (span) {
            this.label.innerHTML = '';
            this.label.appendChild(span);
        }
    }

    activate() {
        this.label.classList.add('is-active');
    }

    deactivate() {
        this.label.classList.remove('is-active');
    }

    checkValue() {
        const hasValue = this.input.value && this.input.value.trim() !== '';
        const isFocused = this.input === document.activeTav;

        if (hasValue || isFocused) {
            this.activate();
        } else {
            this.deactivate();
        }
    }
}
